module.exports = __webpack_public_path__ + "img/robusta-txt.1f2c6bbc.svg";